import { observable, action } from 'mobx';

/**
 * 用户数据
 */
export default class userStore {
  @observable checkPassRestTime = 3;

  // 更改数据
  @action.bound
  setData(data: any) {
    for (const key in data) {
      this[key] = data[key];
    }
  }
}
